export enum SpidGtmRegistrationType {
	SPID = "SPID",
	AAMS = "AAMS",
}

export enum SpidGtmRegistrationMethod {
	SPID = "SPID",
	REGULAR = "Regular",
}

export const REGISTRATION_STEP_PREFIX = "Step" as const;
export const REGISTRATION_TRACKING_CONTINUE_BUTTON_VALUE = "ContinueButton" as const;
export const REGISTRATION_TRACKING_BACK_BUTTON_VALUE = "BackButton" as const;

export enum SpidGtmEventActions {
	REGISTRATION_INTENTION = "RegIntention",
	OPEN_REGISTRATION_PAGE = "OpenRegPage",
	REGISTRATION_FIELD_CHANGE = "RegistrationFieldChange",
	REGISTRATION_SUBMITTED = "RegistrationSubmitted",
	CONFIRMED_REGISTRATION = "ConfirmedRegistration",
	REGISTRATION_FAILED = "FailedRegistration",
}

export interface LastSuccessRegistrationStepData {
	step: number;
	type: SpidGtmRegistrationType;
	method: SpidGtmRegistrationMethod;
}

interface RegistrationStepDataBase {
	RegistrationStep: string;
	RegistrationType: SpidGtmRegistrationType;
	RegistrationMethod: SpidGtmRegistrationMethod;
	event: SpidGtmEventActions;
}

export type RegistrationStepDataRegistrationIntention = RegistrationStepDataBase & { ItemClicked: string };
export type RegistrationStepDataOpenRegistrationPage = RegistrationStepDataBase;
export type RegistrationStepDataRegistrationFieldChange = RegistrationStepDataBase & { FieldName: string };
export type RegistrationStepDataRegistrationSubmitted = RegistrationStepDataBase;
export type RegistrationStepDataConfirmedRegistration = RegistrationStepDataBase & {
	HashedEmail: string;
	GUID: string;
	PartnerID: string;
};
export type RegistrationStepDataRegistrationFailed = RegistrationStepDataBase & { Error: string };
